<script lang="ts">
    import {
        getQuoteImages,
        type ImageQuote as ImageQuoteType,
    } from "@utils/image-editor/image-quote"
    import PopupHeading from "@components/popup/PopupHeading.svelte"
    import { ImageQuotePrefs } from "@utils/image-editor/image-quote-prefs"
    import ImageQuotePrefsEditor from "./ImageQuotePrefsEditor.svelte"
    import ImageQuote from "./ImageQuote.svelte"
    import ImageQuoteSelectee from "./ImageQuoteSelectee.svelte"
    import Icon from "@components/material/Icon.svelte"
    import { QUOTE_BACKGROUNDS } from "@utils/image-editor/files/image-quote-keys"
    import HelpIcon from "@components/help/HelpIcon.svelte"

    export let imageQuote: ImageQuoteType

    const { paragraphNumbers, sentenceNumbers, boldParagraph } = ImageQuotePrefs

    $: quote = imageQuote.copyWords.html({
        paragraphNumbers: $paragraphNumbers,
        sentenceNumbers: $sentenceNumbers,
        boldParagraph: $boldParagraph,
    })

    $: path = imageQuote.copyWords.prettyPath

    $: images = getQuoteImages(quote, path)
    $: images.then((obj) => {
        const allowedKeys = Object.entries(obj)
            .filter(([, { tooBig }]) => !tooBig)
            .map(([key]) => key)
        if (allowedKeys.length) selectedKey = allowedKeys[0]
        allTooMuchText = allowedKeys.length === 0
    })
    const keys = Object.keys(QUOTE_BACKGROUNDS)

    let allTooMuchText = false
    let selectedKey = keys[Math.floor(Math.random() * keys.length)]

    function scrollImageRail(event: WheelEvent) {
        const rail = event.currentTarget as HTMLDivElement
        const scrollsVertically = rail.scrollHeight > rail.clientHeight
        const rawDelta =
            Math.abs(event.deltaY) >= Math.abs(event.deltaX) ? event.deltaY : event.deltaX
        const deltaMultiplier =
            event.deltaMode === WheelEvent.DOM_DELTA_LINE
                ? 16
                : event.deltaMode === WheelEvent.DOM_DELTA_PAGE
                  ? scrollsVertically
                      ? rail.clientHeight
                      : rail.clientWidth
                  : 1
        const delta = rawDelta * deltaMultiplier
        const position = scrollsVertically ? rail.scrollTop : rail.scrollLeft
        const maximum = scrollsVertically
            ? rail.scrollHeight - rail.clientHeight
            : rail.scrollWidth - rail.clientWidth

        if ((delta < 0 && position > 0) || (delta > 0 && position < maximum)) {
            event.preventDefault()
            if (scrollsVertically) rail.scrollTop += delta
            else rail.scrollLeft += delta
        }
    }
</script>

<PopupHeading class="text-center mb-2">Share Quote <HelpIcon path="quote-maker" /></PopupHeading>
<section class="flex gap-4 flex-col sm:flex-row-reverse">
    <div class="flex gap-4 flex-col flex-grow">
        <div>
            {#if images}
                {#await images}
                    <div
                        class="w-full aspect-square relative flex items-center justify-center rounded-xl bg-gray-100 dark:bg-gray-950"
                    >
                        <Icon icon="loading" class="w-8" />
                    </div>
                {:then imagesLoaded}
                    {@const selectedImage = imagesLoaded[selectedKey]}
                    {#if selectedImage}
                        <ImageQuote
                            {allTooMuchText}
                            {quote}
                            url={path}
                            bitmap={selectedImage.bitmap}
                            tooBig={selectedImage.tooBig}
                        />
                    {/if}
                {/await}
            {/if}
        </div>
        <div>
            <ImageQuotePrefsEditor />
        </div>
        <!-- <Button
            go={() => chosenCanvas && downloadQuote(chosenCanvas)}
            icon="share"
            class="w-full sm:flex hidden">Share Quote</Button
        > -->
    </div>
    <div
        role="radiogroup"
        aria-label="Quote background images"
        class="image-picker flex w-full gap-3 overflow-x-auto overflow-y-hidden overscroll-contain p-2 sm:h-[calc(100vh_-_6rem)] sm:w-40 sm:flex-col sm:overflow-x-hidden sm:overflow-y-auto"
        on:wheel|nonpassive={scrollImageRail}
    >
        {#each keys as key}
            <!-- {key} -->
            {#await images}
                <div
                    class="aspect-square relative w-32 h-32 flex items-center justify-center rounded-xl bg-gray-100 dark:bg-gray-950"
                >
                    <Icon icon="loading" class="w-8" />
                </div>
            {:then loadedImages}
                <ImageQuoteSelectee
                    bitmap={loadedImages[key].bitmap}
                    tooBig={loadedImages[key].tooBig}
                    selected={selectedKey === key}
                    on:click={() => (selectedKey = key)}
                />
            {/await}
        {/each}
    </div>
</section>

<style>
    .image-picker {
        scrollbar-color: var(--color-grey-400) transparent;
        scrollbar-width: thin;
    }

    .image-picker::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    .image-picker::-webkit-scrollbar-track {
        background: transparent;
    }

    .image-picker::-webkit-scrollbar-thumb {
        border: 2px solid transparent;
        border-radius: 999px;
        background: var(--color-grey-400);
        background-clip: padding-box;
    }

    .image-picker::-webkit-scrollbar-thumb:hover {
        background: var(--color-grey-500);
        background-clip: padding-box;
    }

    @media (min-width: 640px) {
        .image-picker {
            scrollbar-gutter: stable;
        }
    }

    :global(.darkmode) .image-picker {
        scrollbar-color: var(--color-grey-500) transparent;
    }
</style>
